import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
	KngFooter,
	KngFooterData,
	KngFooterState,
	FooterLabel
} from './definitions/footer.interface';
import { KngFooterFactory } from './kng-footer.factory';
import { KngFooterService } from './kng-footer.service';
@Component({
	selector: 'kng-footer',
	templateUrl: './template/kng-footer.component.html',
	styleUrls: ['./template/kng-footer.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class KngFooterComponent implements KngFooter
{
	private state$: BehaviorSubject<KngFooterState> =
		new BehaviorSubject<KngFooterState>(KngFooterFactory.buildState());
  @Input() set state(value: KngFooterState)
	{
		this.state$.next(value);
		this.footerdata = value;
		this.footercontent = value.footercontent;
	}
  footerdata: KngFooterState = KngFooterFactory.buildState();
  footerLabel = FooterLabel;
  footercontent!: KngFooterData;
  footerStyle: string = '';
  @Output() ctaLinkClicked: EventEmitter<KngFooterState> =
  	new EventEmitter<KngFooterState>();
  @Output() languageSelectionChanged: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('dropdown', { read: ElementRef }) dropdown!: ElementRef;
  get state(): KngFooterState
  {
  	return this.state$.value;
  }

  get isActionFooterPresent(): boolean
  {
  	return this.footerService.isActionFooterPresent;
  }

  constructor(private footerService: KngFooterService) {}
}
